import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE;

const instance = axios.create({
    baseURL,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    },
});
instance.interceptors.response.use(
    (response) => {
        const { data, status } = response;
        if (status === 200) {
            return data;
        }
        return response;
    },
    function (error) {
        // preserve the HTTP status on the rejected payload so callers can react to it (e.g. 403),
        // and guard network errors where error.response is undefined.
        const data = error?.response?.data;
        if (data && typeof data === 'object' && data.status === undefined && error.response?.status) {
            data.status = error.response.status;
        }
        return Promise.reject(data ?? error);
    },
);
instance.interceptors.request.use(function (config) {
    return config;
});

export default instance;
